module.exports = __webpack_public_path__ + "static/media/InsertNotAvailableIcon.5927469a.svg";